import { z } from 'zod';

export const DRAFT_SHADOW_STATUSES = ['pending', 'reviewed', 'no_reply'] as const;
export const DraftShadowStatusSchema = z.enum(DRAFT_SHADOW_STATUSES);
export type DraftShadowStatus = z.infer<typeof DraftShadowStatusSchema>;

export const DRAFT_SHADOW_USES = ['verbatim', 'edited', 'rewritten'] as const;
export const DraftShadowUseSchema = z.enum(DRAFT_SHADOW_USES);
export type DraftShadowUse = z.infer<typeof DraftShadowUseSchema>;

export const AUTO_SEND_BLOCKERS = [
  'verifier-not-passed',
  'action-required',
  'confidence-not-high',
  'injection-risk',
  'member-upset',
  'money-involved',
  'no-reply-needed',
  'claims-mismatch',
  'decision-needs-human',
] as const;
export const AutoSendBlockerSchema = z.enum(AUTO_SEND_BLOCKERS);
export type AutoSendBlocker = z.infer<typeof AutoSendBlockerSchema>;

export const FDA_HOLD_TOPIC = 'order-status · FDA hold';

export const DraftShadowReportQuerySchema = z.object({
  days: z.coerce.number().int().min(1).max(90).default(14),
});
export type DraftShadowReportQuery = z.infer<typeof DraftShadowReportQuerySchema>;

export const DraftShadowTopicRowSchema = z.object({
  topic: z.string(),
  drafts: z.number().int(),
  wouldSend: z.number().int(),
  awaitingReply: z.number().int(),
  noReply: z.number().int(),
  reviewed: z.number().int(),
  judgedRight: z.number().int(),
  sentAsIs: z.number().int(),
  wouldSendReviewed: z.number().int(),
  wouldSendRight: z.number().int(),
});
export type DraftShadowTopicRow = z.infer<typeof DraftShadowTopicRowSchema>;

export const DraftShadowWrongDraftSchema = z.object({
  id: z.uuid(),
  topic: z.string(),
  wouldSend: z.boolean(),
  use: DraftShadowUseSchema.nullable(),
  reason: z.string(),
  conversationUrl: z.string(),
  draftedAt: z.iso.datetime(),
});
export type DraftShadowWrongDraft = z.infer<typeof DraftShadowWrongDraftSchema>;

export const DraftShadowReportSchema = z.object({
  since: z.iso.datetime(),
  topics: z.array(DraftShadowTopicRowSchema),
  wrongDrafts: z.array(DraftShadowWrongDraftSchema),
});
export type DraftShadowReport = z.infer<typeof DraftShadowReportSchema>;
